import type { useCanceledNotificationValues } from './hooks/useCanceledNotificationValues'

export function convertValues(formValues: ReturnType<typeof useCanceledNotificationValues>) {
  return {
    ...formValues,
    includeMessageUnsubscriptionInstructions:
      formValues.notificationWay === 'EMAIL'
        ? formValues.includeMessageUnsubscriptionInstructionsEmail
        : formValues.includeMessageUnsubscriptionInstructionsPhone,
  }
}
